import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, FillPath, StrokePath } from "./shared";

export function IconBruxismSplint(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M8.2 2.4l1.6 1.4 1.6-1.4 1.6 1.4 1.6-1.4 1.6 1.4" />
    </ClinicalIconSvg>
  );
}

export function IconRetentionSplint(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M5 11.6h14" />
    </ClinicalIconSvg>
  );
}

export function IconWhiteningSplint(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M19.2 1.6v4.8M16.8 4h4.8M17.5 2.3l3.4 3.4M20.9 2.3l-3.4 3.4" />
    </ClinicalIconSvg>
  );
}

export function IconInjectionSplint(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M19.4 1.8c1.4 2 2.6 3.4 2.6 4.8a2.6 2.6 0 0 1-5.2 0c0-1.4 1.2-2.8 2.6-4.8Z" />
    </ClinicalIconSvg>
  );
}

export function IconMouthguard(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6H3.2Z" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
    </ClinicalIconSvg>
  );
}

export function IconMandibularAdvancementDevice(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M3.2 5.6c0 8.2 3.6 13.6 8.8 13.6s8.8-5.4 8.8-13.6" />
      <StrokePath d="M6.4 5.6c0 5.6 2.4 9.6 5.6 9.6s5.6-4 5.6-9.6" />
      <StrokePath d="M3.2 5.6h3.2M17.6 5.6h3.2" />
      <StrokePath d="M15.4 20.4h5.6M18.4 18l2.6 2.4-2.6 2.4" />
    </ClinicalIconSvg>
  );
}
